import { Component } from '@angular/core';
import { environment } from '@environments/environment';
import { DowntimeBannerConfig } from '@shared/models/downtime-banner/downtime-banner.model';

@Component({
    selector: 'avenir-downtime-banner',
    imports: [],
    templateUrl: './downtime-banner.component.html',
    styleUrl: './downtime-banner.component.scss'
})
export class DowntimeBannerComponent {
    readonly mascotSrc = 'assets/images/portal-downtime-mascot.png';
    readonly message = $localize`:@@downtimeBannerMessage:The Portal will be unavailable for this time period`;

    readonly config: DowntimeBannerConfig | undefined = environment.DOWNTIME_BANNER;

    readonly shouldShow = this.isBannerVisible(this.config);

    readonly periodLabel = this.config?.periodLabel?.trim() ?? '';

    private isBannerVisible(config: DowntimeBannerConfig | undefined): boolean {
        if (!config?.enabled) {
            return false;
        }

        const now = Date.now();
        const startMs = config.startUtc ? Date.parse(config.startUtc) : Number.NaN;
        const endMs = config.endUtc ? Date.parse(config.endUtc) : Number.NaN;

        if (!Number.isNaN(startMs) && now < startMs) {
            return false;
        }

        if (!Number.isNaN(endMs) && now >= endMs) {
            return false;
        }

        return true;
    }
}
